import { NextSeo } from 'next-seo';
import Head from 'next/head';
import { Link } from '/screens/';

export default function LinkPage() {
  return (
    <>
      <Head>
        <meta
          name="keywords"
          content="transportaion management, freight tracking,"
        />
      </Head>
      <NextSeo
        nofollow={process.env.NOINDEX_FLAG}
        noindex={process.env.NOINDEX_FLAG}
        title="Logistics Integrations"
        description="Add instantly bookable rates and real-time tracking to your transportation management system with easy TMS Integrations."
        canonical="https://loadsmart.com/link/"
        openGraph={{
          url: 'https://loadsmart.com/link/',
        }}
      />
      <Link />
    </>
  );
}
